import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import ResumeDownload from './ResumeDownload';

export interface HomeProps { }

const Home: React.FC<HomeProps> = () => {
    const { t } = useLanguage();

    return (
        <section className="quienSoy">
            <div className="ancho">
                <div className="contenido">
                    <div className="contenedor">
                        <p className="cargo">{t('home_role')}</p>
                        <h1>
                            Jose Eduardo
                            <br />
                            Rendón Valencia
                        </h1>
                        <p className="parrafo">
                            {t('home_bio1')}
                            <br /><br />
                            {t('home_bio2')}
                            <br /><br />
                            {t('home_bio3')}
                            <br /><br />
                            {t('home_bio4')}
                        </p>
                        <div className="home-actions-group">
                            <Link to="/contact" className="home-contact-link">
                                {t('home_contact_btn')}<span></span>
                            </Link>
                            <ResumeDownload variant="button" className="home-cv-download-btn" />
                        </div>
                    </div>
                </div>
                <div className="graficos">
                    <img src="/IMG_8352 (1).png" alt="Jose Eduardo Rendón" className="yo" />
                    <div className="icon icon-react">
                        <img src="/logo-react.svg" alt="React Logo" />
                    </div>
                    <div className="icon icon-wordpress">
                        <img src="/logo-wordpress.svg" alt="WordPress Logo" />
                    </div>
                    <div className="icon icon-laravel">
                        <img src="/logo-laravel.svg" alt="Laravel Logo" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Home;
